/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'SalesFilterTemplateEvent'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('salesfiltertemplateevent'); // main translation loaded for salesfiltertemplateevent
		$translatePartialLoader.addPart('salesfilter'); // one to many reference from main entity
		$translatePartialLoader.addPart('templateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfilter'); // coupling entity reference loaded for salesfilter
		$translatePartialLoader.addPart('templateevent'); // coupling entity reference loaded for templateevent

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-dialog.html';

		return {
			/* new state for entity salesFilterTemplateEvent */
			/* to access: ui-ref="salesfiltertemplateevent.list.new" */
			/* url: hostname/salesfiltertemplateevent/new */
			url: url,
			data: {
				authorities: [],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'SalesFilterTemplateEventDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'SalesFilterTemplateEventFactory',
									'NewSalesFilterTemplateEventFactory',
									function(SalesFilterTemplateEventFactory, NewSalesFilterTemplateEventFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new SalesFilterTemplateEvent
										// - resuming the creation of a new new SalesFilterTemplateEvent AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return SalesFilterTemplateEventFactory.get({ id: $stateParams.salesFilterTemplateEventId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewSalesFilterTemplateEventFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for salesFilterTemplateEvent new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for salesFilterTemplateEvent edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('salesfiltertemplateevent', {
		/* abstract state for entity salesFilterTemplateEvent */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/salesfiltertemplateevent',
		data: {
			authorities: [],
			pageTitle: 'SalesFilterTemplateEvents',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('salesfiltertemplateevent.list', {
		/* list state for entity salesFilterTemplateEvent */
		/* to access: ui-ref="salesfiltertemplateevent.list" */
		/* url: hostname/salesfiltertemplateevent/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevents.html',
				controller: 'SalesFilterTemplateEventController',
			},
		},
	});

	$stateProvider.state('salesfiltertemplateevent.detail', {
		/* detail state for entity salesFilterTemplateEvent */
		/* to access: ui-sref="salesfiltertemplateevent.detail" */
		/* url: hostname/salesfiltertemplateevent/detail/:salesFilterTemplateEventId */
		url: '/detail/:salesFilterTemplateEventId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-detail.html',
				controller: 'SalesFilterTemplateEventDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'SalesFilterTemplateEventFactory',
				function($stateParams, SalesFilterTemplateEventFactory) {
					return SalesFilterTemplateEventFactory.get({ id: $stateParams.salesFilterTemplateEventId });
				},
			],
		},
	});

	$stateProvider.state('user-salesfiltertemplateevent', {
		/* abstract state for DTO UserSalesFilterTemplateEventListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/salesfiltertemplateevent',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'SalesFilterTemplateEvent',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase

			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserSalesFilterTemplateEventListDto */
		/* to access: ui-ref="user-salesfiltertemplateevent.list" */
		/* url: http://<hostname>/user/salesfiltertemplateevent/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-list-user.html',
				controller: 'UserSalesFilterTemplateEventListDtoController',
			},
		},
	};

	$stateProvider.state('user-salesfiltertemplateevent.list', dtoListState);
});
